import type { GetSigninResponse } from '../get';
import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

type ProvideType = 'email' | 'mobile';
type ProvideData = {
    mobile?: string,
    email?: string,
    returnUrl?: string | null,
}

type PostProvideParams = PostGenericEndpointParams<ProvideData> & {
    type: ProvideType;
};

export const postProvide = async ({ data, lang, token, type }: PostProvideParams): Promise<GetSigninResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: `signin/provide-${type}`,
    });
};